// src/router.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Home
import Home from './components/home_page/home';

// About Us
import AboutUs from './components/about_us/about_us';

// Events
import PastEvents from './components/events/past_events';
import UpcomingEvents from './components/events/upcoming_events';
import EventOne from './components/events/Event1';
import EventTwo from './components/events/Event2';
import EventsPage from './components/events/EventsPage';

// Career / Internships
import Career from './components/career/career';
import Exclusive from './components/being_informal_with/informal';
import Internships from './components/internship/informal';

import InformalPlusInternships from './components/being_informal_with/informal';

// Contact
import ContactUs from './components/contact_us/contact_us';
// Forms
import InternshipForm from './components/Forms/internship_form';
import MembershipForm from './components/Forms/membership_form';
//Blogs
import BlogsPage from './Blogs/blogs';

function AppRouter() {
  return (
    <Router>
      <Routes>
        {/* Home */}
        <Route path="/" element={<Home />} />

        {/* About */}
        <Route path="/about" element={<AboutUs />} />

        {/* Events */}
        <Route path="/events/past" element={<PastEvents />} />
        <Route path="/events/upcoming" element={<UpcomingEvents />} />
        <Route path="/events/micro-nuclear-reactor" element={<EventOne />} />
        <Route path="/events/nuclear-codes-for-reactor-analysis" element={<EventTwo />} />
        <Route path="/events" element={<EventsPage />} />

        {/* Career */}
        <Route path="/career" element={<Career />} />
        <Route path="/internships" element={<Internships />} />
        <Route path="/exclusive" element={<Exclusive />} />
        <Route path="/informal-plus-internships" element={<InformalPlusInternships />} />

        {/* Contact */}
        <Route path="/contact" element={<ContactUs />} />

        {/* Forms */}
        <Route path="/internship-form" element={<InternshipForm />} />
        <Route path="/membership-form" element={<MembershipForm />} />

        {/* Blogs */}
        <Route path="/blog" element={<BlogsPage />} />

        {/* Fallback */}
        <Route path="*" element={<h2>404 - Page Not Found</h2>} />
      </Routes>
    </Router>
  );
}

export default AppRouter;
